module.exports = __webpack_public_path__ + "static/media/bg_top.661d7cf8.png";